import { ApolloError, useQuery } from '@apollo/client'
import { SUBORDINATES } from './Queries'
import { SubordinatesQuery, SubordinatesQueryVariables, Country } from '../../types'

export default (
  companyId: string,
  reviewer: boolean,
  buId?: string | null,
): {
  data: SubordinatesQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const variables = {
    companyId: companyId,
    reviewer: reviewer,
    buId: buId,
    country: Country.All,
  }

  const { data, error, loading } = useQuery<SubordinatesQuery, SubordinatesQueryVariables>(SUBORDINATES, {
    variables: variables,
    fetchPolicy: 'network-only',
  })

  return { data, error, loading }
}
